import React, { useEffect, useState } from "react";
import Card2 from "../components/Card2mock";
import { Link, useLocation, useNavigate, useParams } from "react-router-dom";
import { CircularProgress } from "@mui/material";
import PageSEO from "../components/SEO_Component/PageSEO";
import BreadcrumbNav from "../components/BreadcrumbNav";

function CalculatorPage() {
  const { lang } = useParams();
  const [categories, setCalcList] = useState({});
  const [data, setData] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const location = useLocation();
  const pathSegments = location.pathname.split("/");
  const lastSegment = pathSegments[pathSegments.length - 1];

  useEffect(() => {
    setIsLoading(true);
    window.scrollTo({
      top: 0,
      behavior: "instant",
    });
    fetch(`${process.env.REACT_APP_API}${lang}/tools?debug=true`)
      .then((response) => response.json())
      .then((data) => {
        setData(data);
        setCalcList(data["categories"]);
        setIsLoading(false);
      })
      .catch((err) => {
        console.log(err.message);
        setIsLoading(false);
      });
  }, []);
  return (
    <>
      {isLoading && (
        <div className="w-full flex items-center justify-center h-[80vh]">
          <CircularProgress />
        </div>
      )}

      {!isLoading && (
        <div className="h-full flex-col items-center place-items-center">
          <BreadcrumbNav
            pathSegments={data.navigation.filter(
              (item) => item.id === "home" || item.id === `${lastSegment}`
            )}
          />

          <h1 className="mt-4 text-[#00C6CA] text-base md:text-3xl flex justify-center text-center font-montserrat font-semibold ">
            <PageSEO seoData={data.seo} />
            {data.seo && data.seo.h1 ? data.seo.h1 : ""}
          </h1>
          <div className="mt-4 text-[#00000094] text-xs md:text-base flex justify-center text-center font-montserrat font-normal">
            {data.seo && data.seo.seo_title ? data.seo.seo_title : ""}
          </div>

          <div>
            {Object.keys(categories).map((categoryId) => {
              const category = categories[categoryId];
              return (
                <div
                  key={categoryId}
                  className="mt-4 text-[#00000094] text-2xl flex-col justify-center text-center font-montserrat font-semibold"
                >
                  {category.title}
                  <div className="md: grid md:grid-cols-3 px-10 py-6 gap-4 md:px-24 md:py-4 md:gap-3">
                    {category.calculators &&
                      category.calculators.map((calc) => (
                        <Link to={`/${lang}/calculator/${calc.id}`}>
                          <div className="justify-center hover:cursor-pointer">
                            <Card2 img={calc.image} title={calc["title"]} />
                          </div>
                        </Link>
                      ))}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </>
  );
}

export default CalculatorPage;
